import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import IncidenceNote from 'modules/bookkeepers/store/models/IncidenceNote'

export class IncidenceNotes extends Collection<IncidenceNote> {
  get cacheKey(): string {
    return 'incidenceNotes'
  }

  model() {
    return IncidenceNote
  }
}

const singleton: IncidenceNotes = new IncidenceNotes()

export default singleton

const { provider: IncidenceNotesProvider, hook: useIncidenceNotes } = createCollectionContext<
  IncidenceNote,
  IncidenceNotes
>()

export { IncidenceNotesProvider, useIncidenceNotes }
